module.exports = "<div class=\"topbar\">\r\n    <a class=\"topbar-px-logo\" [href]=\"myPayExUrl\"></a>\r\n</div>\r\n<section *ngIf=\"'hide' != ('notification.title' | translate | lowercase)\" class=\"hero-unit hero-unit-full text-center bg-white\">\r\n    <h3 class=\"text-success\">{{'notification.title' | translate}}</h3>\r\n    <p>{{'notification.body' | translate}}</p>\r\n    <a href=\"{{'notification.button_url' | translate}}\" class=\"btn btn-brand\">{{'notification.button_text' | translate }}</a>\r\n</section>\r\n<router-outlet></router-outlet>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app.component.html
 ** module id = 382
 ** module chunks = 0
 **/